import { useTranslation } from 'react-i18next';
import { useLang } from '@/hooks/useLang';

interface InfoSectionProps {
  type: 'review' | 'shipping' | 'coupon' | 'warehouse' | 'legit';
  imageUrl: string;
}

export default function InfoSection({ type, imageUrl }: InfoSectionProps) {
  const { t } = useTranslation();
  const lang = useLang();

  const bgColors: Record<string, string> = {
    review: 'bg-background-50',
    shipping: 'bg-background-100',
    coupon: 'bg-background-50',
    warehouse: 'bg-background-100',
    legit: 'bg-background-50',
  };

  return (
    <section className={`py-14 md:py-20 ${bgColors[type]}`}>
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="w-full lg:w-1/2">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src={imageUrl}
                alt={t(`${type}.h2`)}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
              {t(`${type}.h2`)}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {t(`${type}.description`)}
            </p>
            <a
              href={`/${lang}/allchinabuy-${type}/`}
              className="inline-flex items-center px-5 py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t(`${type}.cta`)}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}